import findAncestor from "./findAncestor";
import {slideUp, slideDown} from 'es6-slide-up-down';
const Packery = require('packery');

export default () => {

    const accordions = document.querySelectorAll('[data-accordion]');

    for(const accordion of accordions) {

        const titles = accordion.querySelectorAll('[data-accordion-title]');
        const items = accordion.querySelectorAll('[data-accordion-item]');

        for (const title of titles) {
            title.addEventListener('click', (e) => {
                e.preventDefault();
                const item = title.parentNode;
                const content = item.querySelector('[data-accordion-content]');
                if (item.classList.contains('active')) { // close this
                    slideUp(content);
                    item.classList.remove('active');
                } else {
                    const activeSlides = accordion.querySelectorAll('.active[data-accordion-item]');
                    for (const activeSlide of activeSlides) {
                        const activeContent = activeSlide.querySelector('[data-accordion-content]');
                        activeSlide.classList.remove('active');
                        slideUp(activeContent)
                    }
                    slideDown(content);
                    item.classList.add('active');
                }

                // packery
                const grid = document.querySelector('.js-packery');
                if (grid) {
                    window.pckry = new Packery( grid, {
                        // options
                        itemSelector: '.approved-reviews__card',
                    });
                }
                return false;
            });

        }


    }

}
